var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_337",
    "data-name": "Group 337",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136.526,
    height: 181.78,
    viewBox: "0 0 136.526 181.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 136.526,
    height: 181.78,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    d: "M57.989,0h1.636a57.989,57.989,0,0,1,57.989,57.989v65.727a57.99,57.99,0,0,1-57.99,57.99H57.99A57.99,57.99,0,0,1,0,123.716V57.989A57.989,57.989,0,0,1,57.989,0Z",
    transform: "translate(9.456)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M127.07,67.886v55.831a57.989,57.989,0,0,1-57.989,57.989H67.445A57.989,57.989,0,0,1,9.456,123.717V67.886A57.989,57.989,0,0,1,67.445,9.9h1.636A57.989,57.989,0,0,1,127.07,67.886",
    fill: "#edbc4f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M109.393,107.44A41.141,41.141,0,1,1,68.252,66.3a41.141,41.141,0,0,1,41.141,41.141",
    fill: "#e3aa44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M61.995,151.037c-1,.668-5.741-4.69-10.584-11.965s-7.955-13.715-6.952-14.383,5.742,4.69,10.584,11.965S63,150.37,61.995,151.037",
    fill: "#4646e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M74.531,151.037c1,.668,5.741-4.69,10.584-11.965s7.955-13.715,6.952-14.383-5.742,4.69-10.584,11.965-7.955,13.716-6.952,14.383",
    fill: "#4646e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M44.167,128.761s7.556-3.66,8.689-5.3,2.519-7.3,4.282-18.386,2.668-30.545,6.7-31.735c2.856-.843,4.076,1.839,4.32,3.607.215,1.558.051,46.9.009,57.674a5.929,5.929,0,0,1-2.943,5.118,16.345,16.345,0,0,1-2.621,1.2l-5.618,7.637s-12.814-6.459-12.815-19.82",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M58.527,94.188s.878-6.142,5.308-6.148,4.428,6.738,4.428,6.738",
    fill: "none",
    stroke: "#e3aa44",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M59.9,84.065s.759-5.451,4.592-5.457,3.76,6.255,3.76,6.255",
    fill: "none",
    stroke: "#e3aa44",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M92.359,128.761s-7.556-3.66-8.689-5.3-2.519-7.3-4.282-18.386-2.668-30.545-6.7-31.735c-2.856-.843-4.076,1.839-4.32,3.607-.214,1.558-.051,46.9-.009,57.674a5.931,5.931,0,0,0,2.943,5.118,16.345,16.345,0,0,0,2.621,1.2l2.733,3.715,2.885,3.922s12.814-6.459,12.815-19.82",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M78,94.188s-.878-6.142-5.308-6.148-4.428,6.738-4.428,6.738",
    fill: "none",
    stroke: "#e3aa44",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M76.626,84.065s-.76-5.451-4.592-5.457-3.76,6.255-3.76,6.255",
    fill: "none",
    stroke: "#e3aa44",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M52.431,123.091c1.133-1.637,2.943-6.932,4.706-18.013s2.669-30.545,6.7-31.735c2.856-.843,4.075,1.839,4.319,3.607.215,1.558.052,46.9.009,57.673a6.847,6.847,0,0,1-2.985,5.631",
    fill: "none",
    stroke: "#e3aa44",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M84.076,123.287c-1.133-1.637-2.925-7.127-4.688-18.209s-2.668-30.545-6.7-31.735c-2.856-.843-4.076,1.839-4.32,3.607-.215,1.558-.051,46.9-.009,57.674a6.28,6.28,0,0,0,2.733,5.435",
    fill: "none",
    stroke: "#e3aa44",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M45.426,125.341c.617,3.248,3.431,12.555,16.179,24.838a.983.983,0,0,1-.014,1.436L24.882,181.78,0,146.761l44.055-22.115a.973.973,0,0,1,1.371.695",
    fill: "#7165fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M11.764,163.317,24.882,181.78l36.709-30.165a.983.983,0,0,0,.014-1.436c-1.557-1.5-2.964-2.956-4.238-4.361-.946-1.044-19.343,17.621-45.6,17.5",
    fill: "#5651f3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 3.264,
    y2: 1.657,
    transform: "translate(24.004 136.62)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 10.21,
    y2: 5.182,
    transform: "translate(29.727 130.19)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M91.1,125.341c-.617,3.248-3.432,12.555-16.179,24.838a.983.983,0,0,0,.014,1.436l36.709,30.165,24.882-35.019L92.471,124.646a.973.973,0,0,0-1.371.695",
    fill: "#7165fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M124.762,163.317,111.644,181.78,74.935,151.615a.983.983,0,0,1-.014-1.436c1.557-1.5,2.964-2.956,4.238-4.361.946-1.044,19.343,17.621,45.6,17.5",
    fill: "#5651f3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 3.264,
    y2: 1.657,
    transform: "translate(109.258 136.62)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x2: 10.209,
    y2: 5.182,
    transform: "translate(96.589 130.19)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M91.352,108.114c1.115-.609,3.374-1.046,3.2-4.067-.024-.4.623-.447.815-.1.633,1.156,1.248,3.34,3.948,3.833.337.061.405.666.077.766-2.394.723-2.707,2.146-3.311,3.885a.444.444,0,0,1-.811.083c-.668-1.228-.7-2.957-3.834-3.592a.439.439,0,0,1-.081-.812",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M43.167,89.484c.959-.523,2.9-.9,2.749-3.5-.02-.343.537-.384.7-.082.544.994,1.072,2.873,3.394,3.3.29.053.348.573.066.659-2.058.622-2.327,1.845-2.847,3.341a.381.381,0,0,1-.7.071c-.575-1.056-.6-2.543-3.3-3.089a.377.377,0,0,1-.069-.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M35.742,110.063c.655-.357,1.981-.614,1.877-2.388-.014-.235.366-.263.479-.057.372.68.733,1.962,2.318,2.251.2.036.238.392.045.45-1.4.425-1.589,1.26-1.944,2.282a.261.261,0,0,1-.476.048c-.392-.721-.411-1.736-2.252-2.109a.258.258,0,0,1-.047-.477",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M86.272,84.087c.655-.357,1.981-.614,1.877-2.388-.014-.235.366-.263.479-.057.372.679.733,1.962,2.318,2.251.2.036.238.392.045.45-1.4.424-1.589,1.26-1.944,2.281a.26.26,0,0,1-.476.049c-.392-.721-.412-1.737-2.252-2.109a.258.258,0,0,1-.047-.477",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPray);
export default __webpack_public_path__ + "static/media/pray.b3eac9cca2448a1a16a332072cf27e04.svg";
export { ForwardRef as ReactComponent };